import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ZapIcon, ThumbsUpIcon, TrendingUpIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: CalendarIcon,
    title: 'Más Citas Agendadas',
    desc: 'Convierte interesados incluso mientras duermes'
  }, {
    icon: ZapIcon,
    title: 'Respuesta Inmediata',
    desc: 'Responde en segundos, no en horas'
  }, {
    icon: ThumbsUpIcon,
    title: 'Clientes Más Fieles',
    desc: 'Una gran experiencia hace que se queden y te recomienden'
  }, {
    icon: TrendingUpIcon,
    title: 'Un Paso Adelante',
    desc: 'Pon tu empresa a la vanguardia con la tecnología que el mundo está adoptando'
  }];
  return <section className="py-24 bg-navy relative dot-pattern" data-id="element-12">
      <div className="max-w-7xl mx-auto px-6" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-15">
            Lo Que Obtienes Con CONECKTA
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-16">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="card-glow p-8 flex flex-col sm:flex-row items-start gap-6" data-id="element-17">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center shrink-0 border border-primary/20" data-id="element-18">
                <benefit.icon className="w-7 h-7 text-primary" data-id="element-19" />
              </div>
              <div data-id="element-20">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-21">
                  {benefit.title}
                </h3>
                <p className="text-muted leading-relaxed" data-id="element-22">{benefit.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}